var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 906.51 648.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{isolation:isolate;}.cls-2{fill:url(#radial-gradient);}.cls-3{mix-blend-mode:overlay;}.cls-4{fill:#fff;}.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-33,.cls-34,.cls-35,.cls-38,.cls-41,.cls-44,.cls-46,.cls-5{mix-blend-mode:multiply;}.cls-5{fill:url(#radial-gradient-2);}.cls-6{fill:url(#linear-gradient);}.cls-7{fill:url(#linear-gradient-2);}.cls-8{fill:url(#linear-gradient-3);}.cls-9{fill:url(#linear-gradient-4);}.cls-10{fill:url(#linear-gradient-5);}.cls-11{fill:url(#linear-gradient-6);}.cls-12{fill:url(#linear-gradient-7);}.cls-13{fill:url(#linear-gradient-8);}.cls-14{fill:url(#linear-gradient-9);}.cls-15{fill:url(#linear-gradient-10);}.cls-16{fill:url(#linear-gradient-11);}.cls-17{fill:url(#linear-gradient-12);}.cls-18{fill:url(#linear-gradient-13);}.cls-19{fill:url(#radial-gradient-3);}.cls-20{fill:url(#radial-gradient-4);}.cls-21{fill:url(#radial-gradient-5);}.cls-22{fill:url(#radial-gradient-6);}.cls-23{fill:url(#radial-gradient-7);}.cls-24{fill:url(#radial-gradient-8);}.cls-25{fill:url(#radial-gradient-9);}.cls-26{fill:url(#linear-gradient-14);}.cls-27{fill:url(#linear-gradient-15);}.cls-28{fill:url(#linear-gradient-16);}.cls-29{fill:url(#linear-gradient-17);}.cls-30{fill:url(#linear-gradient-18);}.cls-31{fill:url(#linear-gradient-19);}.cls-32{fill:url(#linear-gradient-20);}.cls-33{fill:url(#radial-gradient-10);}.cls-34{fill:url(#radial-gradient-11);}.cls-35{fill:url(#radial-gradient-12);}.cls-36{fill:url(#linear-gradient-21);}.cls-37{fill:url(#linear-gradient-22);}.cls-38{fill:url(#radial-gradient-13);}.cls-39{fill:url(#linear-gradient-23);}.cls-40{fill:url(#linear-gradient-24);}.cls-41{fill:url(#radial-gradient-14);}.cls-42{fill:url(#linear-gradient-25);}.cls-43{fill:url(#linear-gradient-26);}.cls-44{fill:url(#radial-gradient-15);}.cls-45{fill:url(#linear-gradient-27);}.cls-46{fill:url(#radial-gradient-16);}.cls-47{fill:url(#linear-gradient-28);}.cls-48{fill:none;}\n        "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 405.41,
    cy: 336.75,
    r: 368.44,
    gradientTransform: "translate(16.45 814.29) rotate(-90) scale(1.21 1.3)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4ea59a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b4f51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 653.84,
    cy: 186.5,
    r: 49.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#042d2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 25.7,
    y1: 574.93,
    x2: 90.63,
    y2: 639.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00ff4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19ce76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 447.67,
    y1: 42.81,
    x2: 512.6,
    y2: 107.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 612.04,
    y1: 42.81,
    x2: 676.97,
    y2: 107.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 682.19,
    y1: 209.68,
    x2: 641.89,
    y2: 169.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19ce76"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ea59a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 695.81,
    y1: 91.17,
    x2: 760.74,
    y2: 156.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 185.96,
    y1: 216.18,
    x2: 125.52,
    y2: 155.73,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 109.46,
    y1: 42.95,
    x2: 174.39,
    y2: 107.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 190.07,
    y1: 184.88,
    x2: 261.31,
    y2: 256.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 22.55,
    y1: 378.33,
    x2: 93.79,
    y2: 449.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 399.85,
    y1: 852.35,
    x2: -133.92,
    y2: 318.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b4f51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4ea59a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 22.54,
    y1: 88.16,
    x2: 93.78,
    y2: 159.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 106.31,
    y1: 233.24,
    x2: 177.54,
    y2: 304.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 273.83,
    y1: 39.8,
    x2: 345.07,
    y2: 111.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 236.6,
    cy: 333.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 154.6,
    cy: 379.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 318.6,
    cy: 381.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 326.6,
    cy: 521.82,
    r: 39.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 403.6,
    cy: 236.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 155.6,
    cy: 478.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 77.6,
    cy: 329.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 360.75,
    y1: 284.61,
    x2: 425.68,
    y2: 349.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 193.22,
    y1: 284.76,
    x2: 258.15,
    y2: 349.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 106.31,
    y1: 426.69,
    x2: 177.55,
    y2: 497.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 22.54,
    y1: 281.61,
    x2: 93.78,
    y2: 352.85,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 360.75,
    y1: 187.89,
    x2: 425.68,
    y2: 252.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#00ff4f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#19ce76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 514.27,
    y1: 737.93,
    x2: -19.5,
    y2: 204.16,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 598.03,
    y1: 654.17,
    x2: 64.27,
    y2: 120.4,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-10",
    cx: 407.6,
    cy: 143.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-11",
    cx: 312.6,
    cy: 193.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 491.75,
    cy: 187.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 354.44,
    y1: 84.86,
    x2: 431.99,
    y2: 162.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 348.43,
    y1: 210.97,
    x2: 267.7,
    y2: 130.24,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-13",
    cx: 74.6,
    cy: 235.82,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 22.54,
    y1: 184.88,
    x2: 93.78,
    y2: 256.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 519.96,
    y1: 211.82,
    x2: 438.33,
    y2: 130.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 570.22,
    cy: 140.71,
    r: 51.5,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 598.43,
    y1: 164.7,
    x2: 516.8,
    y2: 83.08,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 292.44,
    y1: 485.95,
    x2: 341.89,
    y2: 535.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-15",
    cx: 514.81,
    cy: 257.44,
    r: 29.29,
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 489.48,
    y1: 230.83,
    x2: 526.15,
    y2: 267.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-16",
    cx: 243.3,
    cy: 146.29,
    r: 51.5,
    gradientTransform: "translate(174.71 -129.19) rotate(45)",
    xlinkHref: "#radial-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 280.72,
    y1: 180.14,
    x2: 212.49,
    y2: 111.91,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 128.98,
    y: -128.98,
    width: 648.56,
    height: 906.51,
    transform: "translate(777.54 -128.98) rotate(90)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.43,586.33h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.8-2h37.64l18.82-32.59-18.82-32.6H197.63l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,552.74H254.67l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.81-32.6-18.81-32.59H255.82L237,518.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,452H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.82-32.59-18.82-32.6H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,552.74h-40l-20-34.6,20-34.59h40l20,34.59Zm-38.79-2h37.63l18.82-32.6-18.82-32.59H139.45l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,586.33H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.82-32.59-18.82-32.6H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,519.14H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.82-32.59L118.9,452H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,384.76H80.11l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2H118.9l18.82-32.59L118.9,317.58H81.26L62.44,350.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,485.55H21.92L2,451l20-34.59H61.87l20,34.59Zm-38.79-2H60.71L79.53,451,60.71,418.36H23.08L4.26,451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,619.92H21.92L2,585.33l20-34.59H61.87l20,34.59Zm-38.79-2H60.71l18.82-32.59L60.71,552.74H23.08L4.26,585.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,552.74H21.92L2,518.14l20-34.59H61.87l20,34.59Zm-38.79-2H60.71l18.82-32.6L60.71,485.55H23.08L4.26,518.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,418.36H21.92L2,383.76l20-34.59H61.87l20,34.59Zm-38.79-2H60.71l18.82-32.6L60.71,351.17H23.08L4.26,383.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M818.28,115.86H778.34l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2h37.64l18.81-32.59-18.81-32.6H779.49l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M818.28,183.05H778.33l-20-34.59,20-34.6h39.95l20,34.6Zm-38.79-2h37.64l18.81-32.59-18.81-32.6H779.49l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,452H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.82-32.59-18.82-32.6H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,586.33H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.82-32.59-18.82-32.6H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,519.14H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.82-32.59L118.9,452H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,384.76H80.11l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2H118.9l18.82-32.59L118.9,317.58H81.26L62.44,350.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.43,384.76h-40l-20-34.59,20-34.59h40l20,34.59Zm-38.8-2h37.64l18.82-32.59-18.82-32.59H197.63l-18.81,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,418.36h-40l-20-34.6,20-34.59h40l20,34.59Zm-38.79-2h37.63l18.82-32.6-18.82-32.59H139.45l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,485.55h-40l-20-34.6,20-34.59h40l20,34.59Zm-38.79-2h37.63L195.9,451l-18.82-32.59H139.45L120.63,451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,485.55H254.67l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64L312.27,451l-18.81-32.59H255.82L237,451Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.42,519.14H196.48l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2h37.64l18.82-32.59L235.27,452H197.63l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.42,452H196.48l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2h37.64l18.82-32.59-18.82-32.6H197.63l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,418.36H254.67l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.81-32.6-18.81-32.59H255.82L237,383.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,418.36H371l-20-34.6,20-34.59H411l20,34.59Zm-38.79-2h37.64l18.82-32.6-18.82-32.59H372.19l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,452H312.85l-20-34.59,20-34.6h39.94l20,34.6ZM314,450h37.64l18.82-32.59-18.82-32.6H314l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,384.76H312.85l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.59-18.82-32.59H314l-18.81,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,519.14H312.85l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2h37.64l18.82-32.59L351.64,452H314l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,250.29H312.85l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.6L351.64,183.1H314l-18.81,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.17,250.29H429.22l-20-34.6,20-34.59h39.95l20,34.59Zm-38.8-2H468l18.82-32.6L468,183.1H430.37l-18.81,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,283.88H371l-20-34.59,20-34.6H411l20,34.6Zm-38.79-2h37.64l18.81-32.59-18.81-32.6H372.19l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,216.69H371l-20-34.59,20-34.59H411l20,34.59Zm-38.79-2h37.64l18.81-32.59-18.81-32.59H372.19L353.37,182.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,351.07H371l-20-34.59,20-34.6H411l20,34.6Zm-38.79-2h37.64l18.81-32.59-18.81-32.6H372.19l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.17,317.48H429.22l-20-34.6,20-34.59h39.95l20,34.59Zm-38.8-2H468l18.82-32.6L468,250.29H430.37l-18.81,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.17,183.1H429.22l-20-34.59,20-34.6h39.95l20,34.6Zm-38.8-2H468l18.82-32.59L468,115.91H430.37l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.54,183.1H545.59l-20-34.59,20-34.6h39.95l20,34.6Zm-38.79-2h37.63l18.82-32.59-18.82-32.6H546.75l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.35,216.69H487.41l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2H526.2L545,182.1,526.2,149.51H488.56L469.74,182.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.35,149.51H487.41l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2H526.2L545,114.91,526.2,82.32H488.56l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.54,250.29H545.59l-20-34.6,20-34.59h39.95l20,34.59Zm-38.79-2h37.63l18.82-32.6L584.38,183.1H546.75l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M643.72,216.69H603.78l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.59-18.82-32.59H604.93L586.11,182.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M760.09,216.69H720.15l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.59-18.82-32.59H721.3L702.48,182.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M701.91,183.1H662l-20-34.59,20-34.6h39.95l20,34.6Zm-38.79-2h37.63l18.82-32.59-18.82-32.6H663.12l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M760.09,149.51H720.15l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.6L758.94,82.32H721.3l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,82.32H371l-20-34.6,20-34.59H411l20,34.59Zm-38.79-2h37.64l18.81-32.6L409.83,15.13H372.19L353.37,47.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M527.35,82.32H487.41l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2H526.2L545,47.72,526.2,15.13H488.56L469.74,47.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M469.17,115.91H429.22l-20-34.59,20-34.6h39.95l20,34.6Zm-38.8-2H468l18.82-32.59L468,48.72H430.37l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M585.54,115.91H545.59l-20-34.59,20-34.6h39.95l20,34.6Zm-38.79-2h37.63L603.2,81.32l-18.82-32.6H546.75l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M701.91,115.91H662L642,81.32l20-34.6h39.95l20,34.6Zm-38.79-2h37.63l18.82-32.59-18.82-32.6H663.12L644.3,81.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M643.72,149.51H603.78l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.81-32.6L642.57,82.32H604.93l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M643.72,82.32H603.78l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.81-32.6L642.57,15.13H604.93L586.11,47.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M760.09,82.32H720.15l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.6L758.94,15.13H721.3L702.48,47.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,351.17H21.92L2,316.58l20-34.6H61.87l20,34.6Zm-38.79-2H60.71l18.82-32.59L60.71,284H23.08L4.26,316.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,284H21.92L2,249.39l20-34.6H61.87l20,34.6Zm-38.79-2H60.71l18.82-32.59-18.82-32.6H23.08L4.26,249.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,284h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.79-2h37.63l18.82-32.59-18.82-32.6H139.45l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,317.58H80.11l-20-34.6,20-34.59h39.94L140,283Zm-38.79-2H118.9L137.71,283,118.9,250.39H81.26L62.44,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,250.39H80.11l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2H118.9l18.81-32.6L118.9,183.2H81.26L62.44,215.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,351.17h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.8-2h37.64l18.82-32.59L177.08,284H139.44l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,216.79h-40l-20-34.59,20-34.59h40l20,34.59Zm-38.79-2h37.63L195.9,182.2l-18.82-32.59H139.45L120.63,182.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,216.79h-40l-20-34.59,20-34.59h40l20,34.59Zm-38.79-2h37.63l18.82-32.59-18.82-32.59H255.82L237,182.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.42,250.39H196.48l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.6L235.27,183.2H197.63l-18.82,32.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.42,183.2H196.48l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2h37.64l18.82-32.59L235.27,116H197.63l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.42,317.58H196.48l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64L254.09,283l-18.82-32.59H197.63L178.81,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,317.58H312.85l-20-34.6,20-34.59h39.94l20,34.59Zm-38.79-2h37.64L370.46,283l-18.82-32.59H314L295.18,283Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,351.17h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.79-2h37.63l18.82-32.59L293.45,284H255.82L237,316.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,284h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.79-2h37.63l18.82-32.59-18.82-32.6H255.82L237,249.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.87,82.42H21.92L2,47.83l20-34.6H61.87l20,34.6Zm-38.79-2H60.71L79.53,47.83,60.71,15.23H23.08L4.26,47.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,183.2H80.11l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2H118.9l18.81-32.59L118.9,116H81.26l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.86,216.79H21.92L2,182.2l20-34.59H61.86l20,34.59Zm-38.79-2H60.71L79.53,182.2,60.71,149.61H23.07L4.25,182.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.86,149.61H21.92L2,115l20-34.59H61.86l20,34.59Zm-38.79-2H60.71L79.53,115,60.71,82.42H23.07L4.25,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M120.05,116H80.11l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2H118.9l18.81-32.59L118.9,48.83H81.26L62.44,81.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M236.42,116H196.48l-20-34.59,20-34.59h39.94l20,34.59Zm-38.79-2h37.64l18.82-32.59L235.27,48.83H197.63L178.81,81.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,149.61h-40l-20-34.6,20-34.59h40l20,34.59Zm-38.8-2h37.64L195.9,115,177.08,82.42H139.44L120.63,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.24,82.42h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.8-2h37.64L195.9,47.83l-18.82-32.6H139.44l-18.81,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,82.42h-40l-20-34.59,20-34.6h40l20,34.6Zm-38.79-2h37.63l18.82-32.59-18.82-32.6H255.82L237,47.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.61,149.61h-40l-20-34.6,20-34.59h40l20,34.59Zm-38.79-2h37.63L312.27,115,293.45,82.42H255.82L237,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411,149.61H371l-20-34.6,20-34.59h40L431,115Zm-38.79-2h37.63L428.64,115,409.82,82.42H372.19L353.37,115Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,183.2H312.85l-20-34.59,20-34.6h39.94l20,34.6Zm-38.79-2h37.64l18.82-32.59L351.64,116H314l-18.82,32.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.79,116H312.85l-20-34.59,20-34.59h39.94l20,34.59ZM314,114h37.64l18.82-32.59L351.64,48.83H314L295.18,81.42Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139,354.13a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,139,354.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139,421.71a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,139,421.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.6,489a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,61.6,489Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139,489a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,139,489Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.6,
    cy: 148.26,
    r: 3.65,
    transform: "translate(-98.94 147.9) rotate(-67.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.98,
    cy: 81.4,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.6,
    cy: 215.83,
    r: 3.65,
    transform: "translate(-161.29 189.41) rotate(-67.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.98,
    cy: 215.83,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.6,286.73a3.65,3.65,0,1,1,3.65-3.65A3.66,3.66,0,0,1,61.6,286.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.6,421.71a3.65,3.65,0,1,1,3.65-3.65A3.64,3.64,0,0,1,20.6,421.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.6,489a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,20.6,489Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.6,
    cy: 148.26,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.91,
    cy: 517.49,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.65,
    cy: 451.14,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.3,
    cy: 451.14,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.26,
    cy: 451.14,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.26,
    cy: 451.14,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 313.91,
    cy: 451.14,
    r: 3.65,
    transform: "translate(-223.01 568.51) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 351.74,
    cy: 517.49,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 351.74,
    cy: 451.14,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.65,
    cy: 383.45,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.26,
    cy: 383.45,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.91,
    cy: 383.45,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.65,319.52a3.65,3.65,0,1,1,3.64-3.65A3.66,3.66,0,0,1,3.65,319.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.3,319.52a3.65,3.65,0,1,1,3.64-3.65A3.66,3.66,0,0,1,79.3,319.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.26,319.52a3.65,3.65,0,1,1,3.65-3.65A3.66,3.66,0,0,1,119.26,319.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.91,319.52a3.65,3.65,0,1,1,3.64-3.65A3.66,3.66,0,0,1,194.91,319.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.91,319.52a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,313.91,319.52Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.65,
    cy: 249.07,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.3,
    cy: 249.07,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.26,
    cy: 249.07,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 313.91,
    cy: 249.07,
    r: 3.65,
    transform: "translate(-36.33 443.77) rotate(-67.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.65,185.47a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,3.65,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.3,185.47a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,79.3,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M119.26,185.47a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,119.26,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.91,185.47a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,194.91,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.26,185.47a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,238.26,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.91,185.47a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,313.91,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M79.3,119.55a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,79.3,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.91,119.55a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,194.91,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M238.26,119.55a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,238.26,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.91,119.55a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,313.91,119.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.98,
    cy: 552.89,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.56,354.13a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,178.56,354.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.94,354.13a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,255.94,354.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.94,421.71a3.65,3.65,0,1,1,3.64-3.65A3.65,3.65,0,0,1,255.94,421.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.94,489a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,255.94,489Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.56,
    cy: 148.26,
    r: 3.65,
    transform: "translate(-27.04 255.93) rotate(-67.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 255.94,
    cy: 148.26,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.56,
    cy: 81.4,
    r: 3.65,
    transform: "translate(11.07 183.66) rotate(-55.91)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 255.94,
    cy: 81.4,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.56,
    cy: 215.83,
    r: 3.65,
    transform: "translate(-89.4 297.47) rotate(-67.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.56,286.73a3.65,3.65,0,1,1,3.65-3.65A3.66,3.66,0,0,1,178.56,286.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M255.94,286.73a3.65,3.65,0,1,1,3.64-3.65A3.66,3.66,0,0,1,255.94,286.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.56,
    cy: 552.89,
    r: 3.65,
    transform: "translate(-400.44 504.69) rotate(-67.34)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,354.13a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,371.57,354.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,421.71a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,294.19,421.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,489a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,294.19,489Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,489a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,371.57,489Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,219.48a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,294.19,219.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,219.48a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,371.57,219.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 488.18,
    cy: 148.26,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 488.18,
    cy: 81.4,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M488.18,286.73a3.65,3.65,0,1,1,3.65-3.65A3.66,3.66,0,0,1,488.18,286.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M430.23,319.52a3.65,3.65,0,1,1,3.64-3.65A3.66,3.66,0,0,1,430.23,319.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M430.23,185.47a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,430.23,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545.84,185.47a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,545.84,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M430.23,119.55a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,430.23,119.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.3,
    cy: 47.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.26,
    cy: 47.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M235.83,51a3.65,3.65,0,1,1,3.65-3.65A3.66,3.66,0,0,1,235.83,51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 430.23,
    cy: 47.39,
    r: 3.65,
    transform: "translate(221.05 426.32) rotate(-67.39)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M468.71,252.72a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,468.71,252.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M468.71,185.47a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,468.71,185.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M468.71,51a3.65,3.65,0,1,1,3.65-3.65A3.65,3.65,0,0,1,468.71,51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.37,319.52a3.65,3.65,0,1,1,3.64-3.65A3.65,3.65,0,0,1,352.37,319.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.37,252.72a3.65,3.65,0,1,1,3.64-3.65A3.65,3.65,0,0,1,352.37,252.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.37,119.55a3.65,3.65,0,1,1,3.64-3.64A3.64,3.64,0,0,1,352.37,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M543.52,51a3.65,3.65,0,1,1,3.64-3.65A3.65,3.65,0,0,1,543.52,51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 586.87,
    cy: 47.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 662.52,
    cy: 47.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M700.68,185.47a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,700.68,185.47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 701.67,
    cy: 47.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 778.83,
    cy: 47.39,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M545.84,119.55a3.65,3.65,0,1,1,3.64-3.64A3.65,3.65,0,0,1,545.84,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M664.84,119.55a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,664.84,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M701,119.55a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,701,119.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M820,119.55a3.65,3.65,0,1,1,3.65-3.64A3.64,3.64,0,0,1,820,119.55Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 605.14,
    cy: 215.83,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.6,
    cy: 13.94,
    r: 3.65,
    transform: "translate(24.98 65.39) rotate(-67.31)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.98,
    cy: 13.94,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 178.56,
    cy: 13.94,
    r: 3.65,
    transform: "translate(96.92 173.35) rotate(-67.34)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 255.94,
    cy: 13.94,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,17.58a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,294.19,17.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,17.58a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,371.57,17.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.05,354.13a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,412.05,354.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M410.38,420.37a3.65,3.65,0,1,1,3.64-3.65A3.66,3.66,0,0,1,410.38,420.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.05,151.9a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,412.05,151.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.05,286.73a3.65,3.65,0,1,1,3.65-3.65A3.66,3.66,0,0,1,412.05,286.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.05,17.58a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,412.05,17.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 488.18,
    cy: 13.94,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 527.55,
    cy: 148.26,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 527.55,
    cy: 81.4,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 527.55,
    cy: 215.83,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 527.55,
    cy: 13.94,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 643.02,
    cy: 81.4,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 643.02,
    cy: 215.83,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 643.02,
    cy: 13.94,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 758.04,
    cy: 148.26,
    r: 3.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 605.14,
    cy: 13.94,
    r: 3.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.77,17.58a3.65,3.65,0,1,1,3.65-3.64A3.65,3.65,0,0,1,720.77,17.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M61.6,353.13a2.65,2.65,0,1,1,2.65-2.64A2.65,2.65,0,0,1,61.6,353.13Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 138.98,
    cy: 148.26,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 61.6,
    cy: 81.4,
    r: 2.65,
    transform: "translate(-35.03 114.33) rotate(-71.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 20.6,
    cy: 215.83,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M20.6,285.73a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,20.6,285.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139,285.73a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,139,285.73Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 3.65,
    cy: 517.49,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.3,
    cy: 517.49,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 119.26,
    cy: 517.49,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.26,
    cy: 517.49,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.91,520.14a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,313.91,520.14Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 194.91,
    cy: 451.14,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 79.3,
    cy: 383.45,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.26,
    cy: 383.45,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 238.26,
    cy: 315.87,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M3.65,118.56a2.65,2.65,0,1,1,2.64-2.65A2.65,2.65,0,0,1,3.65,118.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.56,420.71a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,178.56,420.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M178.56,488a2.65,2.65,0,1,1,2.65-2.64A2.65,2.65,0,0,1,178.56,488Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,353.13a2.65,2.65,0,1,1,2.65-2.64A2.65,2.65,0,0,1,294.19,353.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,420.71a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,371.57,420.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,150.9a2.65,2.65,0,1,1,2.65-2.64A2.65,2.65,0,0,1,294.19,150.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,150.9a2.65,2.65,0,1,1,2.65-2.64A2.65,2.65,0,0,1,371.57,150.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,84.05a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,294.19,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,285.73a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,294.19,285.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M371.57,285.73a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,371.57,285.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M294.19,555.53a2.65,2.65,0,1,1,2.65-2.64A2.65,2.65,0,0,1,294.19,555.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M430.23,386.1a2.65,2.65,0,1,1,2.64-2.65A2.65,2.65,0,0,1,430.23,386.1Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 545.84,
    cy: 249.07,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M194.91,50a2.65,2.65,0,1,1,2.64-2.65A2.65,2.65,0,0,1,194.91,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M313.91,50a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,313.91,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M468.71,118.56a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,468.71,118.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M352.37,50A2.65,2.65,0,1,1,355,47.39,2.65,2.65,0,0,1,352.37,50Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 778.32,
    cy: 181.49,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 605.14,
    cy: 81.4,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.77,84.05a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,720.77,84.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M412.05,218.48a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,412.05,218.48Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 643.02,
    cy: 148.26,
    r: 2.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 758.04,
    cy: 13.94,
    r: 2.65
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M720.77,218.48a2.65,2.65,0,1,1,2.65-2.65A2.65,2.65,0,0,1,720.77,218.48Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 653.84,
    cy: 186.5,
    r: 49.03
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "34.4 648.56 10.63 607.4 34.4 566.23 81.93 566.23 105.7 607.4 81.93 648.56 34.4 648.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "456.37 116.44 432.6 75.27 456.37 34.11 503.9 34.11 527.67 75.27 503.9 116.44 456.37 116.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "620.74 116.44 596.98 75.27 620.74 34.11 668.27 34.11 692.04 75.27 668.27 116.44 620.74 116.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "620.74 213.16 596.98 171.99 620.74 130.83 668.27 130.83 692.04 171.99 668.27 213.16 620.74 213.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "704.51 164.8 680.74 123.63 704.51 82.47 752.04 82.47 775.8 123.63 752.04 164.8 704.51 164.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "118.16 213.31 94.39 172.14 118.16 130.98 165.69 130.98 189.46 172.14 165.69 213.31 118.16 213.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "118.16 116.58 94.39 75.42 118.16 34.25 165.69 34.25 189.46 75.42 165.69 116.58 118.16 116.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "199.61 265.67 173.54 220.5 199.61 175.34 251.76 175.34 277.84 220.5 251.76 265.67 199.61 265.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "84.24 368.79 32.09 368.79 6.01 413.95 32.09 459.11 84.24 459.11 110.32 413.95 84.24 368.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "84.24 465.51 32.09 465.51 6.01 510.67 32.09 555.84 84.24 555.84 110.32 510.67 84.24 465.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "84.24 78.61 32.09 78.61 6.01 123.78 32.09 168.94 84.24 168.94 110.31 123.78 84.24 78.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "168 223.7 115.85 223.7 89.77 268.86 115.85 314.03 168 314.03 194.08 268.86 168 223.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "335.53 30.25 283.38 30.25 257.3 75.42 283.38 120.58 335.53 120.58 361.6 75.42 335.53 30.25"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 236.6,
    cy: 333.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 154.6,
    cy: 379.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 318.6,
    cy: 381.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 326.6,
    cy: 521.82,
    r: 39.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 403.6,
    cy: 236.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-24",
    cx: 155.6,
    cy: 478.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-25",
    cx: 77.6,
    cy: 329.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "369.45 358.24 345.69 317.08 369.45 275.92 416.99 275.92 440.75 317.08 416.99 358.24 369.45 358.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "201.92 358.39 178.16 317.23 201.92 276.06 249.46 276.06 273.22 317.23 249.46 358.39 201.92 358.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "168 417.15 115.85 417.15 89.78 462.31 115.85 507.48 168 507.48 194.08 462.31 168 417.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "84.23 272.06 32.08 272.06 6.01 317.23 32.08 362.39 84.23 362.39 110.31 317.23 84.23 272.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "369.45 261.52 345.69 220.36 369.45 179.19 416.99 179.19 440.75 220.36 416.99 261.52 369.45 261.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "118.17 406.75 94.4 365.59 118.17 324.42 165.7 324.42 189.46 365.59 165.7 406.75 118.17 406.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "285.69 406.75 261.92 365.59 285.69 324.42 333.22 324.42 356.99 365.59 333.22 406.75 285.69 406.75"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-33",
    cx: 407.6,
    cy: 143.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 312.6,
    cy: 193.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-35",
    cx: 491.75,
    cy: 187.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "364.83 172.8 336.45 123.63 364.83 74.47 421.6 74.47 449.99 123.63 421.6 172.8 364.83 172.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "335.53 126.83 283.38 126.83 257.3 171.99 283.38 217.16 335.53 217.16 361.61 171.99 335.53 126.83"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-38",
    cx: 74.6,
    cy: 235.82,
    r: 51.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "32.09 265.67 6.01 220.5 32.09 175.34 84.24 175.34 110.31 220.5 84.24 265.67 32.09 265.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "456.37 213.16 432.6 171.99 456.37 130.83 503.9 130.83 527.67 171.99 503.9 213.16 456.37 213.16"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-41",
    cx: 570.22,
    cy: 140.71,
    r: 51.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "534.84 166.04 511.07 124.88 534.84 83.72 582.37 83.72 606.14 124.88 582.37 166.04 534.84 166.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "335.27 479.32 299.06 479.32 280.96 510.67 299.06 542.02 335.27 542.02 353.37 510.67 335.27 479.32"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-44",
    cx: 514.81,
    cy: 257.44,
    r: 29.29
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "521.23 225.92 494.39 225.92 480.96 249.17 494.39 272.42 521.23 272.42 534.66 249.17 521.23 225.92"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-46",
    cx: 243.3,
    cy: 146.29,
    r: 51.5,
    transform: "translate(-32.18 214.89) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "195.81 172.78 167.43 123.62 195.81 74.45 252.58 74.45 280.97 123.62 252.58 172.78 195.81 172.78"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 185.1,
    y: -33.68,
    width: 500,
    height: 750,
    transform: "translate(776.42 -93.78) rotate(90)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverBg);
export default __webpack_public_path__ + "static/media/cover-bg.0a0b5c7f2db770473eb9adfc21d662a0.svg";
export { ForwardRef as ReactComponent };